<template>
  <el-dialog
    width="560px"
    top="35vh"
    custom-class="download-modal"
    :visible.sync="val"
  >
    <div class="title">{{ msg }}</div>
    <div class="bottom-container">
      <div class="image ios" @click="iosClick()"></div>
      <div class="image android" @click="androidClick()"></div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "DownloadModalComponent",
  model: {
    // 实现v-model
    prop: "val",
    event: "updateVal",
  },
  props: {
    val: {
      type: Boolean,
      required: true,
    },
    msg: {
      type: String,
      required: true,
    },
  },
  methods: {
    iosClick() {
      window.open(
        "https://itunes.apple.com/us/app/apphi-scheduler-for-instagram/id1251406049?mt=8",
        "_blank"
      );
      this.value = false;
    },
    androidClick() {
      window.open("https://go.onelink.me/app/apphiwebforandroid", "_blank");
      this.value = false;
    },
  },
  data() {
    return {
      value: this.val,
    };
  },
  watch: {
    /**
     * 监听文本值变化，变化时触发updateVal事件，实现双向绑定
     */
    value() {
      this.$emit("updateVal", this.value);
    },
    /**
     * 当props val变化时改变data中value值，从而实现双向绑定
     */
    val(val) {
      this.value = val;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import "../../assets/style/theme.less";

.download-modal {
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__headerbtn {
    top: 16px;
    right: 16px;
  }
  .el-dialog__body {
    padding: 0;
  }
  .title {
    text-align: center;
    font-size: 16px;
    line-height: 24px;
    padding: 40px 37px 0 37px;
    color: black;
    white-space: pre-wrap;
  }
  .bottom-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
    .image {
      width: 162px;
      height: 44px;
      background-size: cover;
      cursor: pointer;
      &.ios {
        background-image: url("../../../public/images/common/download_ios_n@3x.png");
        &:hover {
          background-image: url("../../../public/images/common/download_ios_s@3x.png");
        }
      }
      &.android {
        margin-left: 36px;
        background-image: url("../../../public/images/common/downdoad_android_n@3x.png");
        &:hover {
          background-image: url("../../../public/images/common/downdoad_android_s@3x.png");
        }
      }
    }
  }
}
</style>
